import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { RolesApiClient } from "../../web-api-client";
import { fetchWithTimeout } from "../../utils/fetchWithTimeout";
import { makeFetchWithAuth } from "../../auth/authFetch";
import { appConfig } from "../../appconfig";

export function useRoleAccess(roleId?: string) {
  const navigate = useNavigate();

  return useQuery({
    queryKey: ["role-access", roleId],
    enabled: Boolean(roleId),
    queryFn: async () => {
      const client = new RolesApiClient(appConfig.apiBaseUrl, {
        fetch: makeFetchWithAuth(fetchWithTimeout(), {
          onUnauthorized: () =>
            navigate("/login", {
              replace: true,
              state: { from: window.location.pathname },
            }),
        }),
      });

      return client.getRoleAccess(roleId!);
    },
    staleTime: 60_000, 
    refetchOnWindowFocus: false,
  });
}
